import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
// Component styles
import styles from './styles';
import ScreenshotElement from './ScreenshotElement'
import Period from '../../../../helpers/PeriodScreenshot';
import Grid from '@material-ui/core/Grid';
import moment from 'moment-timezone'
import 'moment/locale/es'
import { Card, CardContent, TextField , Box, DialogContent, DialogTitle} from '@material-ui/core';
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { withTranslation } from 'react-i18next';
import { differenceInSeconds, format } from 'date-fns';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Divider from '@material-ui/core/Divider';
moment.locale('es')



class ScreenshotsRebuild extends Component {
    constructor(props) {
        super(props);
        var nodes=(props.location.state.fromObjective.Nodos)
        var listNodes=[]                                                                                            
        nodes.map(node=>{
            if(node["nodo"]!=='Global'){
                listNodes.push(node)
            }
        })
        var statePeriod={}
        var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD hh:mm:ss"))
        var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD hh:mm:ss"))
        statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
        this.myCallback = this.myCallback.bind(this);
        var monitores=(props.location.state.fromObjective.Monitores)
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        this.state = {
            objetive: this.props.match.params.objetivo_id,
            isStatePeriod: false,
            settingsEl: null,
            steps:this.props.location.state.fromObjective.Pasos,
            isRefresh: false,
            isInfo: null,
            nodes:listNodes,
            listMonitores:monitores,
            dateMoment:((moment().locale('es'))),
            dateBefore:moment().subtract({'hours': 1}).locale('es'),
            limit:moment().subtract({'days': 6}).locale('es'),
            limit2:((moment().locale('es'))),
            errors:["",
                t('screenshots-rebuild.errors.only-one-day'),
                t('screenshots-rebuild.errors.dates-not-equal'),
                t('screenshots-rebuild.errors.start-date-greater'),
                t('screenshots-rebuild.errors.end-date-exceeds'),
                t('screenshots-rebuild.errors.range-one-hour')
            ],
            indexError:0,
            isLoad:false,
            extendEl: null,
            nameNodo: t('screenshots-rebuild.modal.title'),
            node: 0,
            begin: (moment().tz(sessionStorage.getItem('tz')).subtract(1,'hour').format("YYYY-MM-DD HH:mm:ss")),
            end: (moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss")),
            isLoadButton:false,
            modal:false,
            //period: this.props.period,
            period: 'h',
            namePeriod: `${t('text.range')}: ${t('period.text.last-hour')}`,
            isStatePeriod: false,
            periodEl: null,
            namePeriodPorlet: [t('period.text.last-hour'), t('period.text.last-day'), t('period.text.last-week'), t('period.text.custom'), t('period.text.last-3-hours'), t('period.text.last-3-days'), t('period.text.last-6-hours'), t('period.text.last-12-hours')],
            //typePeriod: this.props.typePeriod,
            typePeriod: 0,
            isOneHour: true,
            periodical: false,
            //typeGraph: this.props.typeGrap,
            typeGraph: 0,
            statePeriod: statePeriod,
            pages: 1,
            page: 0,
            service: this.props.location.state.fromObjective.servicio_id,
            clockBegin: format(new Date(new Date().setHours(new Date().getHours() - 1)), 'yyyy-MM-dd HH:mm'),
            clockFinal: format(new Date(), 'yyyy-MM-dd HH:mm'),
            errorIndex: 0
        };
    }

    myCallback = (dataFromChild) => {
        this.setState({
            isLoadButton:false,
        })
    }

    changeDate=()=>{
        const {dateBefore, dateMoment, indexError}=this.state
        if(indexError===0&&(dateBefore.format("YYYY-MM-DD H:mm:ss")!==this.state.begin.format("YYYY-MM-DD H:mm:ss")||
            dateMoment.format("YYYY-MM-DD H:mm:ss")!==this.state.end.format("YYYY-MM-DD H:mm:ss"))){
            this.setState({
                begin:dateBefore,
                end:dateMoment,
                isLoadButton:true,
                modal:false,
            })
        }
    }

    handleNextNodeClick = event => {
        const nameNodo = event.currentTarget.name
        const newNode = event.currentTarget.id
        if (this.state.node !== newNode) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                node: newNode,
                isLastEvent: false,
                extendEl: null,
                isRefresh: false,
                nameNodo: nameNodo,
            })
        }
    }

    handleShowExtend = event => {
        this.setState({
            extendEl: event.currentTarget
        });
    };
    handleCloseExtend = () => {
        this.setState({
            extendEl: null
        });
    };

    handleShowPop = event => {
        this.setState({
            modal: true
        });
    };
    handleClosePop = () => {
        this.setState({
            modal: false
        });
    };

    handleClose = event => {
        this.props.onClose()
    };
    
    onChange=(date)=>{
        
    }

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (nextPeriod === 'hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'hour').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: `${t('text.range')}: ${t('period.text.last-hour')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        } else if (nextPeriod === '3hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(3,'hour').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 4,
                namePeriod: `${t('text.range')}: ${t('period.text.last-3-hours')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        }else if (nextPeriod === '6hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(6,'hour').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: '6h',
                typePeriod: 6,
                namePeriod: `${t('text.range')}: ${t('period.text.last-6-hours')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        }else if (nextPeriod === '12hora') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(12,'hour').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: '12h',
                typePeriod: 7,
                namePeriod: `${t('text.range')}: ${t('period.text.last-12-hours')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        } else if (nextPeriod === 'dia') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: `${t('text.range')}: ${t('period.text.last-day')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        } /*else if (nextPeriod === '3dia') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(3,'day').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: 'Rango: últimos 3 días',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        } else if (nextPeriod === 'semana') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'week').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: 'Rango: última semana',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        }*/ else if (nextPeriod === 'custom') {
            var startDate = moment(statePeriod).format("YYYY-MM-DD HH:mm:ss")
            var endDate = moment(statePeriod).add('days', 1).format("YYYY-MM-DD HH:mm:ss")
            statePeriod = {startDate: startDate, endDate: endDate, key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: `${t('text.range')}: ${startDate.substring(0, 10)} ${t('text.to2')} ${endDate.substring(0, 10)}`,
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate, 
            });
        }
        //this.getDataFromAPI();
    }


    handleChangePage = (e, page)=>{
        this.setState({
            page : page
        })
    }

    // 2. Método en el Padre para cambiar el color seleccionado:
    handleColorChange = (color) => {
        this.setState({ selectedColor: color });
    };

    render() {
        
        const { classes, location } = this.props;
        const {listMonitores, nodes, steps, objetive, dateMoment, dateBefore, isLoad, extendEl, nameNodo, node, limit,
            errors, indexError, limit2, begin, end, isLoadButton, modal, 
            statePeriod, namePeriodPorlet, typeGraph, typePeriod, isOneHour, periodEl, periodical, period, namePeriod, page, pages, service, 
            selectedColor = 'all'} = this.state;
        const showExtendEl = Boolean(extendEl);
        const showPeriodEl = Boolean(periodEl);
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (isLoad===true) {
            return(
                <AtCircularProgress />
            )
        }else{
            return (
                <Card className={classes.backGrey}>
                    <DialogTitle className='at-blue-background'>
                        <Box display='flex' flexDirection='row' width='100%' alignItems='center' justifyContent='space-between'>
                            <Box>
                                <Typography style={{color:'white'}} variant="h4" className='card__text--dark-color'>Screenshots</Typography>
                                {/*<Typography style={{color:'white'}} variant="caption" className='card__text--dark-color'>{namePeriod}</Typography>*/}
                            </Box>
                            <Box>
                                {/*<Button style={{fontSize:'14px', color:'white'}} className='card__text--dark-color' onClick={this.handleShowPeriod}>
                                    {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon />
                                </Button>
                                <Popover
                                    anchorEl={periodEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                    }}
                                    onClose={this.handleClosePeriod}
                                    open={showPeriodEl}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center'
                                    }}>
                                        <Period onClick={this.handlePeriodClick} range={statePeriod} period={period} periodical={periodical} typeGraph={typeGraph} isOneHour={isOneHour}/>
                                </Popover>*/}
                                <IconButton key="close" aria-label="close" onClick={this.handleClose}><CloseIcon/></IconButton>
                            </Box>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} style={{ paddingTop: 10 }} alignItems="center">
                            {/* Campo Desde */}
                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    type='datetime-local'
                                    variant='outlined'
                                    size='small'
                                    label={t('text.from')}
                                    InputLabelProps={{ shrink: true }}
                                    value={this.state.clockBegin}
                                    onChange={e => this.setState({ clockBegin: e.target.value, errorIndex: 0 })}
                                    error={Boolean(this.state.errorIndex)}
                                    helperText={errors[this.state.errorIndex || 0]}
                                />
                            </Grid>

                            {/* Campo Hasta */}
                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    type='datetime-local'
                                    variant='outlined'
                                    size='small'
                                    label={t('text.to')}
                                    InputLabelProps={{ shrink: true }}
                                    value={this.state.clockFinal}
                                    onChange={e => this.setState({ clockFinal: e.target.value, errorIndex: 0 })}
                                />
                            </Grid>
                            
                            {/* FILA 2: Botones de Estado (Izquierda) */}
                            <Grid item xl={8} lg={8} md={8} sm={8} xs={12} style={{ textAlign: 'left' }}>
                                <ButtonGroup size="small" aria-label="small outlined button group" style={{ gap: '4px' }}>
                                    <Button 
                                        color="primary"
                                        variant={selectedColor === 'all' ? 'contained' : 'outlined'}
                                        onClick={() => this.handleColorChange('all')}
                                        style={{ 
                                            borderRight: selectedColor === 'all' ? 'none' : '1px solid #FF8B32'
                                        }}
                                    >
                                        {t('objective.status.all')}
                                    </Button>
                                    <Button 
                                        style={{ 
                                            backgroundColor: selectedColor === '#41B900' ? '#41B900' : 'transparent', 
                                            color: selectedColor === '#41B900' ? 'white' : '#41B900',
                                            borderColor: '#41B900'
                                        }}
                                        onClick={() => this.handleColorChange('#41B900')}
                                    >
                                        {t('objective.status.uptime')}
                                    </Button>
                                    <Button 
                                        style={{ 
                                            backgroundColor: selectedColor === '#C2272D' ? '#C2272D' : 'transparent', 
                                            color: selectedColor === '#C2272D' ? 'white' : '#C2272D',
                                            borderColor: '#C2272D'
                                        }}
                                        onClick={() => this.handleColorChange('#C2272D')}
                                    >
                                        {t('objective.status.downtime')}
                                    </Button>
                                </ButtonGroup>
                            </Grid>

                            {/* FILA 2: Botón Filtrar (Mismo nivel a la Derecha) */}
                            <Grid item xl={4} lg={4} md={4} sm={4} xs={12} style={{ textAlign: "right" }}>
                                <Button 
                                    variant="outlined" 
                                    color="primary"
                                    onClick={() => {
                                        const { clockBegin, clockFinal } = this.state;

                                        if (!clockBegin || !clockFinal) return;

                                        const start = moment(clockBegin);
                                        const end = moment(clockFinal);
                                        
                                        if (start.isSame(end)) {
                                            this.setState({ errorIndex: 2 });
                                            return;
                                        }

                                        if (start.isAfter(end)) {
                                            this.setState({ errorIndex: 3 }); 
                                            return;
                                        }

                                        const diffInHours = end.diff(start, 'hours', true);
                                        if (diffInHours > 24) {
                                            this.setState({ errorIndex: 1}); 
                                            return;
                                        }

                                        this.setState({
                                            errorIndex: 0,
                                            begin: start.format("YYYY-MM-DD HH:mm:ss"),
                                            end: end.format("YYYY-MM-DD HH:mm:ss")
                                        });
                                    }}
                                >
                                    {t('base-registers-plus.button.filter')}
                                </Button>
                            </Grid>

                            {/* FILA 3: Selector Popover (Debajo) */}
                            <Grid item xs={12} style={{ textAlign: "left" }}>
                                <Button
                                    color="primary"
                                    variant="text"
                                    onClick={this.handleShowExtend}
                                >
                                    {nameNodo} <ArrowDropDownIcon />
                                </Button>
                                
                                <Popover
                                    anchorEl={extendEl}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                    onClose={this.handleCloseExtend}
                                    open={showExtendEl}
                                >
                                    <div className="row1">
                                        <List component="div">
                                            {Object.values(location.state.fromObjective.Nodos).map(i => (
                                                <ListItem key={i.id_nodo} className={classes.listItem} component="div">
                                                    <Button id={i.id_nodo} name={i.nodo} onClick={(event) => this.handleNextNodeClick(event)}>{i.nodo}</Button> 
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div> 
                                </Popover> 
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <Divider></Divider>
                    <CardContent>
                        <ScreenshotElement monitors={listMonitores} nodes={nodes} node={node} objective={objetive} steps={steps} 
                            dateBegin={begin} dateFinal={end} callbackFromParent={this.myCallback} service={service} selectedColor={selectedColor}
                        />
                    </CardContent>
                </Card>
            )
        
        }

        
    }
}


export default
    compose(withRouter, withStyles(styles), withTranslation())(ScreenshotsRebuild);